import URL from 'url'
import obtainResponseErrorMessage from '../helpers/obtainResponseErrorMessage'

const apiError = (status, responseErrorData) => {
  const err = new Error(obtainResponseErrorMessage(responseErrorData));
  err.status = status;
  return err;
};

const isNotSuccess = status => status !== 200

const filterAPIError = res => {
  if (isNotSuccess(res.status)) {
    return res.json().then(responseErrorData => {
      throw apiError(res.status, responseErrorData);
    });
  }
  return res;
}

export default (cfToken, state, publicApiUri) => {
  const request = URL.parse(`${publicApiUri}/basic-authorize`);
  request.query = { cfToken, state };

  return fetch(request.format(), {credentials: 'include'})
    .then(filterAPIError);
}



// WEBPACK FOOTER //
// ./src/app/helpers/authoriseWithCFToken.js